import { render, staticRenderFns } from "./ExpandableRail.vue?vue&type=template&id=205edb04&scoped=true"
import script from "./ExpandableRail.vue?vue&type=script&lang=js"
export * from "./ExpandableRail.vue?vue&type=script&lang=js"
import style0 from "./ExpandableRail.vue?vue&type=style&index=0&id=205edb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205edb04",
  null
  
)

export default component.exports